module.exports = __webpack_public_path__ + "static/media/Physics Award.b41a8241.jpeg";